import { useParamAsInteger } from '@cibo/ui'
import { UserProgramsList } from 'components/UserProgramsList'
import { Section } from '../../../consts/Theme'
import { UserLayout } from '../../UserProfile'

export const GrowerPrograms = () => {
  const userId = useParamAsInteger('userId')

  if (!userId) return null

  return (
    <UserLayout>
      <Section sx={{ padding: 3 }}>
        <UserProgramsList userId={userId} />
      </Section>
    </UserLayout>
  )
}
